
<!-- modificar solicitud supervisor -->
<a href="javascript:void(0);" id="_top{{ cellValue?.data?.id }}" class="me-2" data-bs-toggle="tooltip"
    *ngIf="cellValue?.data?.maintenance_status?.name == 'Nivel 0' && canDo('Mantenimiento de unidades','Modificar solicitud')"
    (click)="modifyMaintenance()" data-bs-placement="top" title="Modificar solicitud">
    <img src="../../../../assets/img/icons/edit.svg" alt="" [width]="'20'">
</a>

<!-- solicitar autorizacion supervisor -->
<a href="javascript:void(0);"
    *ngIf="cellValue?.data?.required_supplier == true 
        && ['Pendiente', 'Nivel 0'].includes(cellValue?.data?.maintenance_status?.name) 
        && canDo('Mantenimiento de unidades','Solicitar autorizacion')"
    id="_top{{ cellValue?.data?.id }}" class="me-2" (click)="getAddSupplier()" data-bs-toggle="tooltip"
    data-bs-placement="top" title="Solicitar autorización">
    <img src="../../../../assets/img/icons/maintenance/file-security.svg" alt="" [width]="'20'">
</a>

<!-- descargar solicitud supervisor opcional(administrativo, directivo) -->
<a href="javascript:void(0);" id="_top{{ cellValue?.data?.id }}" class="me-2" data-bs-toggle="tooltip"
    *ngIf="cellValue?.data?.maintenance_status?.name != 'Cancelado' && canDo('Mantenimiento de unidades','Descargar solicitud')"
    (click)="downloadInvoice()" data-bs-placement="top" title="Descargar solicitud">
    <img src="../../../../assets/img/icons/file-download.svg" alt="" [width]="'20'">
</a>

<!-- detalle de solicitud directivo-->
<a href="javascript:void(0);" id="_top{{ cellValue?.data?.id }}"
    *ngIf="!['Pendiente', 'Nivel 0'].includes(cellValue?.data?.maintenance_status?.name) && 
        canDo('Mantenimiento de unidades','Detalle de solicitud')"
    class="me-2" data-bs-toggle="tooltip" data-bs-placement="top" title="Detalle de Solicitud"
    (click)="detailSolicitud()">
    <img src="../../../../assets/img/icons/maintenance/file-search.svg" alt="" [width]="'20'">
</a>

<!-- comparativo directivo-->
<a href="javascript:void(0);" id="_top{{ cellValue?.data?.id }}"
    *ngIf="
        cellValue?.data?.maintenance_status?.name == 'Por autorizar' && 
        canDo('Mantenimiento de unidades','Comparativo')"
    (click)="getSupplierComparison()" class="me-2"
    data-bs-toggle="tooltip" data-bs-placement="top" title="Comparativos de proveedores">
    <img src="../../../../assets/img/icons/maintenance/catalogue.svg" alt="" [width]="'20'">
</a>

<!-- seguimiento de solicitud supervisor-->
<a href="javascript:void(0);" id="_top{{ cellValue?.data?.id }}" (click)="getTracking()"
    *ngIf="cellValue?.data?.maintenance_status?.name == 'Autorizado' && 
        canDo('Mantenimiento de unidades','Seguimiento de solicitud')" class="me-2" data-bs-toggle="tooltip"
    data-bs-placement="top" title="Seguimiento de solicitud">
    <img src="../../../../assets/img/icons/maintenance/file-export.svg" alt="" [width]="'20'">
</a>

<!-- solicitar pago supervisor-->
<a href="javascript:void(0);" id="_top{{ cellValue?.data?.id }}" (click)="getPayment(1)"
    *ngIf="
        cellValue?.data?.maintenance_status?.name == 'Autorizado' && 
        canDo('Mantenimiento de unidades','Solicitar pago')" class="me-2" data-bs-toggle="tooltip"
    data-bs-placement="top" title="Solicitar pago">
    <img src="../../../../assets/img/icons/maintenance/credit-card.svg" alt="" [width]="'20'">
</a>

<!-- adjuntar comprobante administrativo-->
<a href="javascript:void(0);" id="_top{{ cellValue?.data?.id }}" (click)="getPayment(2)"
    *ngIf="
        ['Pendiente de pago', 'Anticipo'].includes(cellValue?.data?.administrative_status?.name) && 
        canDo('Mantenimiento de unidades','Adjuntar comprobante')" 
    class="me-2"
    data-bs-toggle="tooltip" data-bs-placement="top" title="Adjuntar comprobante">
    <img src="../../../../assets/img/icons/maintenance/document-attachment.svg" alt="" [width]="'20'">
</a>

<!-- cambios de estado admistrativo -->
<a href="javascript:void(0);" id="_top{{ cellValue?.data?.id }}" class="me-2" (click)="getChangeStatus(1)"
    *ngIf="cellValue?.data?.maintenance_status?.name != 'Denegado' 
        && cellValue?.data?.maintenance_status?.name != 'Cancelado' 
        && ['Pagado', 'Anticipo'].includes(cellValue?.data?.maintenance_status?.name) 
        && role == 'Administrativo'
        && canDo('Mantenimiento de unidades','Cambiar de estado')"
    data-bs-toggle="tooltip" data-bs-placement="top" title="Cambiar de estado">
    <img src="../../../../assets/img/icons/maintenance/circle-arrow-reload-02-sharp.svg" alt="" [width]="'20'">
</a>

<!-- cambios de estado supervisor -->
<a href="javascript:void(0);" id="_top{{ cellValue?.data?.id }}" class="me-2" (click)="getChangeStatus(2)" 
    *ngIf="!['Denegado', 'Cancelado', 'Por autorizar', 'Autorizado'].includes(cellValue?.data?.maintenance_status?.name) && 
        ['Administrador', 'Supervisor de mantenimiento'].includes(role) &&
        canDo('Mantenimiento de unidades','Cambiar de estado')
        " data-bs-toggle="tooltip" data-bs-placement="top"
    title="Cambiar de estado">
    <img src="../../../../assets/img/icons/maintenance/circle-arrow-reload-02-sharp.svg" alt="" [width]="'20'">
</a>

<a href="javascript:void(0);" id="_top{{ cellValue?.data?.id }}" class="me-2" (click)="openModalPaymentMade()"
    *ngIf="['Pagado', 'Anticipo', 'Pago facturado'].includes(cellValue?.data?.administrative_status?.name) &&
        canDo('Mantenimiento de unidades','Pagos realizados')
        " data-bs-toggle="tooltip" data-bs-placement="top"
    title="Pagos realizados">
    <i class="ti ti-receipt" style="font-size: 1.5rem; color: #10a5e2;"></i>
    <!-- <img src="../../../../assets/img/icons/maintenance/circle-arrow-reload-02-sharp.svg" alt="" [width]="'20'"> -->
</a>

<!-- cancelar solicitud -->
<a href="javascript:void(0);" id="_top{{ cellValue?.data?.id }}" class="me-2" data-bs-toggle="tooltip"
    *ngIf="!['Denegado', 'Cancelado', 'Por autorizar', 'Autorizado', 'Pagado', 'Anticipo', 'En reparación'].includes(cellValue?.data?.maintenance_status?.name) && 
        canDo('Mantenimiento de unidades','Cancelar solicitud')"
    (click)="cancelStatus()" data-bs-placement="left" title="Cancelar solicitud">
    <img src="../../../../assets/img/icons/maintenance/cancel-circle.svg" alt="" [width]="'20'">
</a>